import { Routes } from '@angular/router';
import { CompanyDashboardIntegrationsComponent } from '@app/admin/admin-modules/admin-integrations/admin-integrations-components/admin-integrations-navigation/admin-integrations-navigation.component';
import { CreateDirectoryComponent } from '@app/admin/admin-modules/admin-integrations/admin-integrations-components/integration-active-directory/create-directory/create-directory.component';
import { IntegrationActiveDirectoryComponent } from '@app/admin/admin-modules/admin-integrations/admin-integrations-components/integration-active-directory/integration-active-directory.component';
import { IntegrationPeopleHRComponent } from './admin-integrations-components/integration-people-hr/integration-people-hr.component';
import { IntegrationSlackCancellationComponent } from './admin-integrations-components/integration-slack/integration-slack-cancellation/integration-slack-cancellation.component';
import { IntegrationSlackCompletionComponent } from './admin-integrations-components/integration-slack/integration-slack-completion/integration-slack-completion.component';
import { IntegrationSlackComponent } from './admin-integrations-components/integration-slack/integration-slack.component';
import { IntegrationVincereComponent } from './admin-integrations-components/integration-vincere/integration-vincere.component';
import { IntegrationSagehrComponent } from './admin-integrations-components/integration-sagehr/integration-sagehr.component';
import { IntegrationZendeskComponent } from './admin-integrations-components/integration-zendesk/integration-zendesk.component';
import { IntegrationTriNetComponent } from './admin-integrations-components/integration-trinet/integration-trinet.component';
import { IntegrationEvaluagentComponent } from './admin-integrations-components/integration-evaluagent/integration-evaluagent.component';
import { IntegrationMergeComponent } from 'app/admin/admin-modules/admin-integrations/admin-integrations-components/integration-merge/integration-merge.component';

import { FeatureGuard } from '@app/shared/auth/feature.guard';
import { CompanyFeatures } from '@app/models/company-features.model';
import { IntegrationAbsorblmsComponent } from './admin-integrations-components/integration-absorblms/integration-absorblms.component';
import { IntegrationZendeskQaComponent } from './admin-integrations-components/integration-zendesk-qa/integration-zendesk-qa.component';

export const AdminIntegrationsRoutes: Routes = [
  {
    path: '',
    component: CompanyDashboardIntegrationsComponent,
    data: { label: 'Integrations' },
    children: [
      {
        path: 'slack',
        component: IntegrationSlackComponent,
        data: { label: 'Slack' },
        children: [
          {
            path: 'completion',
            component: IntegrationSlackCompletionComponent,
            data: { label: 'Success' },
          },
          {
            path: 'cancellation',
            component: IntegrationSlackCancellationComponent,
            data: { label: 'Cancelled' },
          },
        ],
      },
      {
        path: 'active-directory',
        component: IntegrationActiveDirectoryComponent,
        canActivate: [ FeatureGuard ],
        data: {
          label: 'Active Directory',
          feature: CompanyFeatures.AZURE_ACTIVE_DIRECTORY
        },
        children: [
          {
            path: 'create-directory',
            component: CreateDirectoryComponent,
            data: { label: 'Create Directory' },
          },
        ],
      },
      {
        path: 'people-hr',
        component: IntegrationPeopleHRComponent,
        canActivate: [ FeatureGuard ],
        data: {
          label: 'People HR',
          feature: CompanyFeatures.PEOPLE_HR
        },
      },
      {
        path: 'vincere',
        component: IntegrationVincereComponent,
        canActivate: [ FeatureGuard ],
        data: {
          label: 'Vincere',
          feature: CompanyFeatures.VINCERE
        },
      },
      {
        path: 'zendesk',
        component: IntegrationZendeskComponent,
        canActivate: [ FeatureGuard ],
        data: {
          label: 'Zendesk',
          feature: CompanyFeatures.ZENDESK
        },
      },
      {
        path: 'evaluagent',
        component: IntegrationEvaluagentComponent,
        canActivate: [ FeatureGuard ],
        data: {
          label: 'Evaluagent',
          feature: CompanyFeatures.EVALUAGENT
        },
      },
      {
        path: 'absorblms',
        component: IntegrationAbsorblmsComponent,
        canActivate: [ FeatureGuard ],
        data: {
          label: 'Absorb LMS',
          feature: CompanyFeatures.ABSORBLMS
        },
      },
      {
        path: 'trinet',
        component: IntegrationTriNetComponent,
        canActivate: [ FeatureGuard ],
        data: {
          label: 'TriNet',
          feature: CompanyFeatures.TRINET_HRIS
        },
      },
      {
        path: 'sagehr',
        component: IntegrationSagehrComponent,
        canActivate: [ FeatureGuard ],
        data: {
          label: 'Sage HR',
          feature: CompanyFeatures.SAGE_HR
        },
      },
      {
        path: 'merge',
        component: IntegrationMergeComponent,
        canActivate: [ FeatureGuard ],
        data: {
          label: 'Merge',
          feature: CompanyFeatures.MERGE
        }
      },
      {
        path: 'zendeskqa',
        component: IntegrationZendeskQaComponent,
        canActivate: [ FeatureGuard ],
        data: {
          label: 'ZendeskQA',
          feature: CompanyFeatures.ZENDESKQA
        },
      },
    ],
  },
];
